(function ($, Drupal) {

  const jvmCountries = {
    'AF': { 'name': 'Afghanistan', 'coords': [33, 65] },
    'EG': { 'name': 'Ägypten', 'coords': [27, 30] },
    'AL': { 'name': 'Albanien', 'coords': [41, 20] },
    'DZ': { 'name': 'Algerien', 'coords': [28, 3] },
    'AO': { 'name': 'Angola', 'coords': [-12.5, 18.5] },
    'GQ': { 'name': 'Äquatorialguinea', 'coords': [2, 10] },
    'AR': { 'name': 'Argentinien', 'coords': [-34, -64] },
    'AM': { 'name': 'Armenien', 'coords': [40, 45] },
    'AZ': { 'name': 'Aserbaidschan', 'coords': [40.5, 47.5] },
    'ET': { 'name': 'Äthiopien', 'coords': [8, 38] },
    'AU': { 'name': 'Australien', 'coords': [-27, 133] },
    'BS': { 'name': 'Bahamas', 'coords': [24.25, -76] },
    'BD': { 'name': 'Bangladesch', 'coords': [24, 90] },
    'BE': { 'name': 'Belgien', 'coords': [50.8333, 4] },
    'BZ': { 'name': 'Belize', 'coords': [17.25, -88.75] },
    'BJ': { 'name': 'Benin', 'coords': [9.5, 2.25] },
    'BT': { 'name': 'Bhutan, Königreich', 'coords': [27.5, 90.5] },
    'BO': { 'name': 'Bolivien', 'coords': [-17, -65] },
    'BA': { 'name': 'Bosnien-Herzegowina', 'coords': [44, 18] },
    'BW': { 'name': 'Botsuana', 'coords': [-22, 24] },
    'BR': { 'name': 'Brasilien', 'coords': [-10, -55] },
    'BN': { 'name': 'Brunei Darussalam', 'coords': [4.5, 114.6667] },
    'BG': { 'name': 'Bulgarien', 'coords': [43, 25] },
    'BF': { 'name': 'Burkina Faso', 'coords': [13, -2] },
    'BI': { 'name': 'Burundi', 'coords': [-3.5, 30] },
    'CL': { 'name': 'Chile', 'coords': [-30, -71] },
    'TW': { 'name': 'China, Republik (Taiwan)', 'coords': [23.5, 121] },
    'CN': { 'name': 'China, Volksrepublik', 'coords': [35, 105] },
    'CR': { 'name': 'Costa Rica', 'coords': [10, -84] },
    'DK': { 'name': 'Dänemark', 'coords': [56, 10] },
    'DE': { 'name': 'Deutschland', 'coords': [51, 9] },
    'DO': { 'name': 'Dominikanische Republik', 'coords': [19, -70.6667] },
    'DJ': { 'name': 'Dschibuti', 'coords': [11.5, 43] },
    'EC': { 'name': 'Ecuador', 'coords': [-2, -77.5] },
    'SV': { 'name': 'El Salvador', 'coords': [13.8333, -88.9167] },
    'CI': { 'name': 'Côte d\'Ivoire', 'coords': [8, -5] },
    'ER': { 'name': 'Eritrea, Republik', 'coords': [15, 39] },
    'EE': { 'name': 'Estland', 'coords': [59, 26] },
    'FK': { 'name': 'Falkland Inseln (Islas Malvinas)', 'coords': [-51.75, -59] },
    'FJ': { 'name': 'Fidschi', 'coords': [-18, 175] },
    'FI': { 'name': 'Finnland', 'coords': [64, 26] },
    'FR': { 'name': 'Frankreich', 'coords': [46, 2] },
    'TF': { 'name': 'Französische Südgebiete', 'coords': [-43, 67] },
    'GA': { 'name': 'Gabun', 'coords': [-1, 11.75] },
    'GM': { 'name': 'Gambia', 'coords': [13.4667, -16.5667] },
    'GE': { 'name': 'Georgien (Südkaukasus)', 'coords': [42, 43.5] },
    'GH': { 'name': 'Ghana', 'coords': [8, -2] },
    'GR': { 'name': 'Griechenland', 'coords': [39, 22] },
    'GL': { 'name': 'Grönland', 'coords': [72, -40] },
    'GT': { 'name': 'Guatemala', 'coords': [15.5, -90.25] },
    'GN': { 'name': 'Guinea', 'coords': [11, -10] },
    'GW': { 'name': 'Guinea-Bissau', 'coords': [12, -15] },
    'GY': { 'name': 'Guyana, Kooperative Republik', 'coords': [5, -59] },
    'HT': { 'name': 'Haiti', 'coords': [19, -72.4167] },
    'HN': { 'name': 'Honduras', 'coords': [15, -86.5] },
    'IN': { 'name': 'Indien', 'coords': [20, 77] },
    'ID': { 'name': 'Indonesien', 'coords': [-5, 120] },
    'IQ': { 'name': 'Irak', 'coords': [33, 44] },
    'IR': { 'name': 'Iran, Islamische Republik', 'coords': [32, 53] },
    'IE': { 'name': 'Irland', 'coords': [53, -8] },
    'IS': { 'name': 'Island', 'coords': [65, -18] },
    'IL': { 'name': 'Israel', 'coords': [31.5, 34.75] },
    'IT': { 'name': 'Italien', 'coords': [42.8333, 12.8333] },
    'JM': { 'name': 'Jamaika', 'coords': [18.25, -77.5] },
    'JP': { 'name': 'Japan', 'coords': [36, 138] },
    'YE': { 'name': 'Jemen', 'coords': [15, 48] },
    'JO': { 'name': 'Jordanien', 'coords': [31, 36] },
    'KH': { 'name': 'Kambodscha', 'coords': [13, 105] },
    'CM': { 'name': 'Kamerun', 'coords': [6, 12] },
    'CA': { 'name': 'Kanada', 'coords': [60, -95] },
    'KZ': { 'name': 'Kasachstan', 'coords': [48, 68] },
    'QA': { 'name': 'Katar (Qatari)', 'coords': [25.5, 51.25] },
    'KE': { 'name': 'Kenia', 'coords': [1, 38] },
    'KG': { 'name': 'Kirgisistan', 'coords': [41, 75] },
    'CO': { 'name': 'Kolumbien', 'coords': [4, -72] },
    'CD': { 'name': 'Demokratische Republik Kongo', 'coords': [0, 25] },
    'CG': { 'name': 'Kongo, Republik', 'coords': [-1, 15] },
    'KP': { 'name': 'Korea, Demokratische Volksrepublik', 'coords': [40, 127] },
    'KR': { 'name': 'Korea, Republik', 'coords': [37, 127.5] },
    'HR': { 'name': 'Kroatien', 'coords': [45.1667, 15.5] },
    'CU': { 'name': 'Kuba', 'coords': [21.5, -80] },
    'KW': { 'name': 'Kuwait', 'coords': [29.3375, 47.6581] },
    'LA': { 'name': 'Laos, Demokratische Volksrepublik', 'coords': [18, 105] },
    'LS': { 'name': 'Lesotho, Königreich', 'coords': [-29.5, 28.5] },
    'LV': { 'name': 'Lettland', 'coords': [57, 25] },
    'LB': { 'name': 'Libanon', 'coords': [33.8333, 35.8333] },
    'LR': { 'name': 'Liberia', 'coords': [6.5, -9.5] },
    'LY': { 'name': 'Libyen', 'coords': [25, 17] },
    'LT': { 'name': 'Litauen', 'coords': [56, 24] },
    'LU': { 'name': 'Luxemburg', 'coords': [49.75, 6.1667] },
    'MG': { 'name': 'Madagaskar', 'coords': [-20, 47] },
    'MW': { 'name': 'Malawi', 'coords': [-13.5, 34] },
    'MY': { 'name': 'Malaysia', 'coords': [2.5, 112.5] },
    'ML': { 'name': 'Mali', 'coords': [17, -4] },
    'MA': { 'name': 'Marokko', 'coords': [32, -5] },
    'MR': { 'name': 'Mauretanien', 'coords': [20, -12] },
    'MK': { 'name': 'Mazedonien (ehem jugoslawische Republik)', 'coords': [41.8333, 22] },
    'MX': { 'name': 'Mexiko', 'coords': [23, -102] },
    'MN': { 'name': 'Mongolei', 'coords': [46, 105] },
    'MZ': { 'name': 'Mosambik', 'coords': [-18.25, 35] },
    'MM': { 'name': 'Myanmar', 'coords': [22, 98] },
    'NA': { 'name': 'Namibia', 'coords': [-22, 17] },
    'NP': { 'name': 'Nepal', 'coords': [28, 84] },
    'NC': { 'name': 'Neukaledonien', 'coords': [-21.5, 165.5] },
    'NZ': { 'name': 'Neuseeland', 'coords': [-41, 174] },
    'NI': { 'name': 'Nicaragua', 'coords': [13, -85] },
    'NL': { 'name': 'Niederlande', 'coords': [52.5, 5.75] },
    'NE': { 'name': 'Niger', 'coords': [16, 8] },
    'NG': { 'name': 'Nigeria', 'coords': [10, 8] },
    'NO': { 'name': 'Norwegen', 'coords': [62, 10] },
    'OM': { 'name': 'Oman', 'coords': [21, 57] },
    'AT': { 'name': 'Österreich', 'coords': [47.3333, 13.3333] },
    'PK': { 'name': 'Pakistan', 'coords': [30, 70] },
    'PS': { 'name': 'Palästinensische Gebiete', 'coords': [32, 35.25] },
    'PA': { 'name': 'Panama', 'coords': [9, -80] },
    'PG': { 'name': 'Papua-Neuguinea', 'coords': [-6, 147] },
    'PY': { 'name': 'Paraguay', 'coords': [-23, -58] },
    'PE': { 'name': 'Peru', 'coords': [-10, -76] },
    'PH': { 'name': 'Philippinen', 'coords': [13, 122] },
    'PL': { 'name': 'Polen', 'coords': [52, 20] },
    'PT': { 'name': 'Portugal', 'coords': [39.5, -8] },
    'PR': { 'name': 'Puerto Rico', 'coords': [18.25, -66.5] },
    'MD': { 'name': 'Republik, Moldau', 'coords': [47, 29] },
    'ME': { 'name': 'Republik Montenegro', 'coords': [42, 19] },
    'RS': { 'name': 'Republik Serbien', 'coords': [44, 21] },
    'RW': { 'name': 'Ruanda', 'coords': [-2, 30] },
    'RO': { 'name': 'Rumänien', 'coords': [46, 25] },
    'RU': { 'name': 'Russische Föderation', 'coords': [60, 100] },
    'SB': { 'name': 'Salomonen', 'coords': [-8, 159] },
    'ZM': { 'name': 'Sambia', 'coords': [-15, 30] },
    'SA': { 'name': 'Saudi Arabien', 'coords': [25, 45] },
    'SE': { 'name': 'Schweden', 'coords': [62, 15] },
    'CH': { 'name': 'Schweiz', 'coords': [47, 8] },
    'SN': { 'name': 'Senegal', 'coords': [14, -14] },
    'SL': { 'name': 'Sierra Leone', 'coords': [8.5, -11.5] },
    'ZW': { 'name': 'Simbabwe', 'coords': [-20, 30] },
    'SK': { 'name': 'Slowakische Republik', 'coords': [48.6667, 19.5] },
    'SI': { 'name': 'Slowenien', 'coords': [46, 15] },
    'SO': { 'name': 'Somalia', 'coords': [10, 49] },
    'XS': { 'name': 'Somalia / Somaliland', 'coords': [0, 0] },
    'ES': { 'name': 'Spanien', 'coords': [40, -4] },
    'LK': { 'name': 'Sri Lanka (ehem Ceylon)', 'coords': [7, 81] },
    'ZA': { 'name': 'Südafrika', 'coords': [-29, 24] },
    'SD': { 'name': 'Sudan, Republik', 'coords': [15, 30] },
    'SS': { 'name': 'Südsudan', 'coords': [15, 30] },
    'SR': { 'name': 'Suriname', 'coords': [4, -56] },
    'SZ': { 'name': 'Swasiland', 'coords': [-26.5, 31.5] },
    'SY': { 'name': 'Syrien', 'coords': [35, 38] },
    'TJ': { 'name': 'Tadschikistan', 'coords': [39, 71] },
    'TZ': { 'name': 'Tansania', 'coords': [-6, 35] },
    'TH': { 'name': 'Thailand', 'coords': [15, 100] },
    'TG': { 'name': 'Togo', 'coords': [8, 1.1667] },
    'TT': { 'name': 'Trinidad und Tobago', 'coords': [11, -61] },
    'TD': { 'name': 'Tschad', 'coords': [15, 19] },
    'CZ': { 'name': 'Tschechische Republik', 'coords': [49.75, 15.5] },
    'TN': { 'name': 'Tunesien', 'coords': [34, 9] },
    'TR': { 'name': 'Türkei', 'coords': [39, 35] },
    'TM': { 'name': 'Turkmenistan', 'coords': [40, 60] },
    'UG': { 'name': 'Uganda', 'coords': [1, 32] },
    'UA': { 'name': 'Ukraine', 'coords': [49, 32] },
    'HU': { 'name': 'Ungarn', 'coords': [47, 20] },
    'UY': { 'name': 'Uruguay', 'coords': [-33, -56] },
    'UZ': { 'name': 'Usbekistan', 'coords': [41, 64] },
    'VU': { 'name': 'Vanuatu', 'coords': [-16, 167] },
    'VE': { 'name': 'Venezuela', 'coords': [8, -66] },
    'AE': { 'name': 'Vereinigte Arabische Emirate', 'coords': [24, 54] },
    'US': { 'name': 'Vereinigte Staaten von Amerika', 'coords': [38, -97] },
    'GB': { 'name': 'Vereinigtes Königreich Großbritannien', 'coords': [54, -2] },
    'VN': { 'name': 'Vietnam', 'coords': [16, 106] },
    'BY': { 'name': 'Weißrußland (Belarus)', 'coords': [53, 28] },
    'CF': { 'name': 'Zentralafrikanische Republik', 'coords': [7, 21] },
    'CY': { 'name': 'Zypern', 'coords': [35, 33] },
  };

  $(document).ready(function () {

    let i;
    let countries;
    let countriesInfo;
    let isoCode;
    const worldMapEl = $('.world_map');
    const worldMapElSelection = $('.world_map_selection');
    const countryMapEl = $('.country_map');
    const zoomMax = 8; // default 8

    if (worldMapEl.length > 0) {
      const objCountry = {};
      countriesInfo = JSON.parse($('.countryInfo').text());
      countries = {};
      for (i = 0; i < countriesInfo.length; i++) {
        objCountry[i] = JSON.parse(countriesInfo[i]);

        for (isoCode in jvmCountries) {

          if (jvmCountries[isoCode].name === objCountry[i].name) {
            countries[isoCode] = {
              name: objCountry[i].name,
              region: objCountry[i].region,
              coords: jvmCountries[isoCode].coords,
              global_hunger_index: objCountry[i].global_hunger_index,
              hunger_index_percent: objCountry[i].hunger_index_percent,
              we_help_since: objCountry[i].we_help_since,
              people_get_help: objCountry[i].people_get_help,
              url: objCountry[i].url,
              isoAlpha2: objCountry[i].isoAlpha2

            };
          }
        }
      }
      initWorldMap(worldMapEl, countries, zoomMax);

      const listEl = $('.list_select');
      createRegionList(worldMapEl, countries, listEl);
      createCountryListAppendRegion(worldMapEl, countries, listEl)

    } else if (countryMapEl.length > 0) {
      const iso = countryMapEl.attr('data-iso');
      initCountryMap(countryMapEl, iso);
    }
    else if (worldMapElSelection.length > 0) {
      const objCountrySelection = {};
      countriesInfo = JSON.parse($('.countryInfo').text());
      countries = {};
      for (i = 0; i < countriesInfo.length; i++) {
        objCountrySelection[i] = JSON.parse(countriesInfo[i]);

        for (isoCode in jvmCountries) {
          if (jvmCountries[isoCode].name === objCountrySelection[i].name) {
            countries[isoCode] = {
              name: objCountrySelection[i].name,
              region: objCountrySelection[i].region,
              coords: jvmCountries[isoCode].coords,
              global_hunger_index: objCountrySelection[i].global_hunger_index,
              hunger_index_percent: objCountrySelection[i].hunger_index_percent,
              we_help_since: objCountrySelection[i].we_help_since,
              people_get_help: objCountrySelection[i].people_get_help,
              url: objCountrySelection[i].url,
              isoAlpha2: objCountrySelection[i].isoAlpha2
            };
          }
        }
      }

      var isos = worldMapElSelection.attr('data-countries').split(',');
      initCountryMaps(worldMapElSelection, countries, isos);
    }
  });// Document ready

  function initWorldMap(worldMapEl, countries, zoomMax) {
    worldMapEl.vectorMap({
      map: 'world_mill',
      backgroundColor: '#C3D3DA',
      zoomOnScroll: false,
      panOnDrag: true,
      selectedRegions: countries,
      zoomMax: zoomMax,
      regionStyle: {
        initial: {
          fill: '#ffffff',
          "fill-opacity": 1,
          stroke: 'none',
          "stroke-width": 0,
          "stroke-opacity": 1
        },
        hover: {
          "fill-opacity": 1,
          cursor: 'default'
        },
        selected: {
          fill: '#52AE32'
        },
        selectedHover: {
          fill: '#005EB6',
          cursor: 'pointer'
        }
      },
      regionLabelStyle: {
        initial: {
          'font-family': 'Verdana',
          'font-size': '12',
          'font-weight': 'bold',
          cursor: 'default',
          fill: 'black'
        },
        hover: {
          cursor: 'pointer',
          fill: 'green'
        }
      },
      onRegionTipShow: function (e, el, code) {
        if (countries[code] !== undefined) {

          const name = (countries[code].name !== undefined) ? '<div class="country futura">' + countries[code].name + '</div>' : '';
          const year = (countries[code].we_help_since !== undefined) ? '<div class="mapInfo">Wir helfen seit: <span>' + countries[code].we_help_since + '</span></div>' : '';
          const getHelp = (countries[code].people_get_help !== undefined) ? '<div class="mapInfo">Hilfsempfänger: <span>' + countries[code].people_get_help + '</span></div>' : '';
          const index = (countries[code].global_hunger_index !== undefined) ? '<div class="mapInfo">Welthungerindex: <span>' + countries[code].global_hunger_index + '</span></div>' : '';
          const indexPercent = (countries[code].hunger_index_percent !== undefined) ? '<div class="mapInfo">Unterernährungsrate: <span>' + countries[code].hunger_index_percent + '</span></div>' : '';

          const url = (countries[code].url !== undefined) ? '<a href="' + countries[code].url + '" class="link_big">zum Land</a>' : '';

          el[0].attributes[0].nodeValue = 'jvectormap-tip animated pulse duration-300';
          el.html('<div class="jvectormap_tip_inner">' + name + year + getHelp + index + indexPercent + url + '</div>');
        } else {
          e.preventDefault();
        }

      },
      onRegionOut: function (e, code) {
        if (countries[code] !== undefined) {
          const mapTip = $('.jvectormap-tip');
          mapTip.on('mouseover', function (e) {
            e.currentTarget.style.display = "block";
          });
          mapTip.on('mouseout', function () {
            mapTip.css({display: "none"});
          });

        } else if (countries[code] === undefined) {
          e.preventDefault();
        }

      },
      onRegionClick: function (event, code) {
        if (countries[code] !== undefined) {
          window.location.href = countries[code].url;
        }
      }

    });

  }

  function initCountryMap(countryMapEl, iso) {

    countryMapEl.vectorMap({
      map: 'world_mill',
      selectedRegions: iso,
      backgroundColor: '#ffffff',
      zoomOnScroll: false,
      zoomButtons: false,
      panOnDrag: false,
      zoomMax: 35,
      zoomMin: 5,
      regionStyle: {
        initial: {
          fill: '#E9E8E0',
          'fill-opacity': 1,
          stroke: '#c6c6c6',
          'stroke-width': 0,
          'stroke-opacity': 1
        },
        hover: {
          'fill-opacity': 1,
          'stroke-width': 0,
          cursor: 'default'
        },
        selected: {
          fill: '#0061BC',
          stroke: '#0061BC'
        },
        selectedHover: {
          fill: '#0061BC',
          cursor: 'default'
        }
      },
      regionLabelStyle: {
        initial: {
          fill: '#0061BC'
        }
      },
      onRegionClick: function (e) {
        e.preventDefault();
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
      }
    });

    var map = countryMapEl.vectorMap('get', 'mapObject');

    map.setFocus({
      region: iso
    });

    jvm.$(map.container).unbind('touchmove');

    const baseScaleFacotr = 8;
    const offsetXFromBaseFactor = 23;
    const offsetYFromBaseFactor = 33;

    if ($('.wrapper_info_box').length > 0) {

      jvm.Map.prototype.getRegionCentroid = function (region) {
        if (typeof region == "string")
          region = this.regions[region.toUpperCase()];

        var bbox = region.element.shape.getBBox(),
            xcoord = (((bbox.x + bbox.width / 2) + map.transX) * map.scale),
            ycoord = (((bbox.y + bbox.height / 2) + map.transY) * map.scale);
        return this.pointToLatLng(xcoord, ycoord);
      };

      jvm.Map.prototype.getNewScale = function (region) {
        if (typeof region == "string")
          region = this.regions[region.toUpperCase()];

        const bbox = region.element.shape.getBBox();
        let scale = map.scale;
        if (bbox.width > 80) {
          scale = map.scale - (4.5 * bbox.width / 100);
        }
        return scale;
      };

      jvm.Map.prototype.getNewScaleMobile = function () {
        let newScale = map.scale * 0.7;
        if(newScale < 0.5){
          newScale = 0.5;
        }
        return newScale;
      };

      const windowWidth = $(window).outerWidth();
      const centroid = map.getRegionCentroid(iso);
      if (windowWidth < 1124) {
        const newScaleMobile = map.getNewScaleMobile();
        const topFaktor = offsetYFromBaseFactor / newScaleMobile;
        const newMobileConfig = {
          scale: newScaleMobile,
          lat: centroid.lat - topFaktor,
          lng: centroid.lng,
        };
        map.setFocus(newMobileConfig);
      }

      if (windowWidth >= 1124) {
        const newScale = map.getNewScale(iso);
        const rightFaktor = offsetXFromBaseFactor * baseScaleFacotr / newScale;
        const newConfig = {
          scale: newScale,
          lat: centroid.lat,
          lng: centroid.lng - rightFaktor,
        };
        map.setFocus(newConfig);
      }
    }

    $(window).on('resize', function () {
      const windowWidth = $(this).outerWidth();

      map.setFocus({
        region: iso
      });

      if ($('.wrapper_info_box').length > 0) {
        const centroid = map.getRegionCentroid(iso);
        if (windowWidth < 1124) {
          const newScaleMobile = map.getNewScaleMobile();
          const topFaktor = offsetYFromBaseFactor / newScaleMobile;
          const newMobileConfig = {
            scale: newScaleMobile,
            lat: centroid.lat - topFaktor,
            lng: centroid.lng,
          };
          map.setFocus(newMobileConfig);
        }

        if (windowWidth >= 1124) {
          const newScale = map.getNewScale(iso);
          const rightFaktor = offsetXFromBaseFactor * baseScaleFacotr / newScale;
          const newConfig = {
            scale: newScale,
            lat: centroid.lat,
            lng: centroid.lng - rightFaktor,
          };
          map.setFocus(newConfig);
        }
      }
    });
  }

  function initCountryMaps(countryMapEl, countries, isos) {

    countryMapEl.vectorMap({
      map: 'world_mill',
      selectedRegions: isos,
      backgroundColor: '#C3D3DA',
      zoomOnScroll: false,
      panOnDrag: true,
      zoomButtons: true,
      zoomMax: 35,
      zoomMin: 0,
      regionStyle: {
        initial: {
          fill: '#ffffff',
          "fill-opacity": 1,
          stroke: 'none',
          "stroke-width": 0,
          "stroke-opacity": 1
        },
        hover: {
          "fill-opacity": 1,
          cursor: 'default'
        },
        selected: {
          fill: '#005EB6'
        }
      },
      onRegionTipShow: function (e, el, code) {
        if (jvmCountries[code] !== undefined) {
          const name = (jvmCountries[code].name !== undefined) ? '<div class="country futura">' + jvmCountries[code].name + '</div>' : '';
          el[0].attributes[0].nodeValue = 'jvectormap-tip solo animated pulse duration-300';
          el.html('<div class="jvectormap_tip_inner">' + name + '</div>');
        } else {
          e.preventDefault();
        }
      },
      onRegionOut: function (e, code) {
        if (jvmCountries[code] !== undefined) {
          const mapTip = $('.jvectormap-tip');
          mapTip.on('mouseover', function (e) {
            e.currentTarget.style.display = "block";
          });
          mapTip.on('mouseout', function () {
            mapTip.css({display: "none"});
          });

        } else if (countries[code] === undefined) {
          e.preventDefault();
        }
      },
    });

    const map = countryMapEl.vectorMap('get', 'mapObject');

    jvm.$(map.container).unbind('touchmove');

    jvm.Map.prototype.getCentroid = function (regions) {
      let bbox;
      for (let i = 0; i < regions.length; i++) {
        if (this.regions[regions[i]]) {
          const itemBbox = this.regions[regions[i]].element.shape.getBBox();
          if (itemBbox) {
            if (typeof bbox == 'undefined') {
              bbox = itemBbox;
            } else {
              bbox = {
                x: Math.min(bbox.x, itemBbox.x),
                y: Math.min(bbox.y, itemBbox.y),
                width: Math.max(bbox.x + bbox.width, itemBbox.x + itemBbox.width) - Math.min(bbox.x, itemBbox.x),
                height: Math.max(bbox.y + bbox.height, itemBbox.y + itemBbox.height) - Math.min(bbox.y, itemBbox.y),
              };
            }
          }
        }
      }
      const xcoord = (((bbox.x + bbox.width / 2) + map.transX) * map.scale);
      const ycoord = (((bbox.y + bbox.height / 2) + map.transY) * map.scale);
      return this.pointToLatLng(xcoord, ycoord);
    };
    map.setFocus({
      regions: isos
    });
    const center = map.getCentroid(isos);
    let newMapScale = map.scale;
    const windowWidth = $(this).outerWidth();
    if(windowWidth >= 620){
      newMapScale = map.scale * 0.9;
    }
    else {
      newMapScale = map.scale * 1.3;
    }
    if (newMapScale <= 0.5) {
      newMapScale = 0.5
    }
    map.setFocus({
      scale: newMapScale,
      lat: center.lat,
      lng: center.lng
    });
    $(window).on('resize', function () {
      map.setFocus({
        regions: isos
      });
      const center = map.getCentroid(isos);
      let newMapScale = map.scale;
      const windowWidth = $(this).outerWidth();
      if(windowWidth >= 620){
        newMapScale = map.scale * 0.9;
      }
      else {
        newMapScale = map.scale * 1.2;
      }
      if (newMapScale <= 0.5) {
        newMapScale = 0.5
      }
      map.setFocus({
        scale: newMapScale,
        lat: center.lat,
        lng: center.lng
      });
    });
  }

  function createRegionList(worldMapEl, countries, listEl) {
    const regLi = listEl.next().children();
    listEl.on('click touch', function (e) {
      listEl.next().slideToggle();
    });

    $.each(regLi, function () {
      const that = $(this);
      const reg = that.attr('data-region');

      const regions = [];
      $.each(countries, function (i) {
        if (countries[i].region.toLowerCase().replace(' ', '-') === reg) {
          regions.push('"' + countries[i].isoAlpha2 + '"');
        }
      });
      that.attr('data-regions', '[' + regions + ']');
    });

    $(document).on('click touch', '.region_list_item .item', function (e) {
      const that = $(this);
      that.parent().find('.country_list').slideToggle();
      const currentScroll = that.parents('.region_list').scrollTop();
      const offsetTop = that.parent().position().top + currentScroll - 50;
      that.parents('.region_list').animate({
        scrollTop: offsetTop
      }, 400);
    });
  }

  function createCountryListAppendRegion(worldMapEl, countries, listEl) {
    const regionLiItem = $('.region_list_item');
    regionLiItem.append($('<ul class="country_list"></ul>'));
    $.each(regionLiItem, function (i) {
      const that = $(this);
      const reg = that.attr('data-region');
      $.each(countries, function (i) {
        const name = countries[i].name;
        if (countries[i].region.toLowerCase().replace(' ', '-') === reg) {
          that.children('ul.country_list').append($('<li data-iso="' + countries[i].isoAlpha2 + '" class="country_list_item">' + name + '</li>'));
        }
      });
    });
    $(document).on('click touch', '.country_list_item', function (e) {
      const that = $(this);
      const shouldDirectLink = that.parents('.region_list').hasClass('direct_link');
      if(shouldDirectLink){
        const code = that.attr('data-iso');
        window.location.href = countries[code].url;
      }
      else {
        const region = that.attr('data-iso');
        if (e.target !== this) return;
        $('.jvectormap-region[data-code!=""]').css('fill', '#ffffff');
        $('[data-code="' + region + '"]').mouseover().css('fill', '#52ae32');
        const position = listEl.offset();
        $('.jvectormap-tip').css({top: position.top + 80, left: 0, right: 0, margin: 'auto'});

        listEl.text(e.target.innerText).next().slideUp();
        worldMapEl.vectorMap('get', 'mapObject').setFocus({region: region, animate: true, zoomMax: 8});
      }
    })
  }

})(jQuery, Drupal);
